// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kc9bQt0IvjVjWS {
  z-index: 10;
  margin: 0 2px;
  border-radius: 16px;
  background-color: var(--ds-surface-raised, #ffffff);
  padding: 6px;
}
.kc9bQt0IvjVjWS:hover {
  background-color: var(--ds-surface-raised-hovered, #f1f2f4);
}
.kc9bQt0IvjVjWS:active {
  background-color: var(--ds-surface-raised-pressed, #dcdfe4);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mirrorCardFeedback": `kc9bQt0IvjVjWS`
};
export default ___CSS_LOADER_EXPORT___;
